// ================================
// STAFF PIN ACTIVATION
// First login for a newly-added staff member — a lightweight two-factor
// check: admin hands them a username separately from the phone number
// already on file, and both have to match before a PIN can be set. Nothing
// is ever texted either way.
// ================================
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

export default function StaffActivate() {
  const [username, setUsername] = useState('');
  const [phone, setPhone]       = useState('');
  const [pin, setPin]         = useState('');
  const [confirmPin, setConfirmPin] = useState('');
  const [error, setError]     = useState('');
  const [loading, setLoading] = useState(false);
  const { activateStaff }     = useAuth();
  const navigate               = useNavigate();

  async function handleActivate(e) {
    e.preventDefault();
    setError('');
    if (pin !== confirmPin) { setError('PINs do not match'); return; }
    if (pin.length < 4) { setError('PIN must be at least 4 digits'); return; }

    setLoading(true);
    try {
      await activateStaff(username, phone, pin);
      navigate('/staff/dashboard');
    } catch (err) {
      setError(err.response?.data?.error || 'Could not activate this account');
    } finally { setLoading(false); }
  }

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex', alignItems: 'center', justifyContent: 'center'
    }}>
      <div style={{
        width: 340, background: '#06091a',
        border: '1px solid #0a1628', borderRadius: 20, padding: 36
      }}>
        <div style={{ textAlign: 'center', marginBottom: 28 }}>
          <div style={{
            width: 60, height: 60, borderRadius: '50%',
            background: 'linear-gradient(135deg,#0d1b3e,#1a0a0a)',
            border: '2px solid #1e6bff',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            margin: '0 auto 12px'
          }}>
            <span style={{ fontFamily: 'Bebas Neue,sans-serif', fontSize: 28, color: '#c0101a' }}>W</span>
          </div>
          <h2 style={{ fontFamily: 'Bebas Neue,sans-serif', fontSize: 24, letterSpacing: 3, color: '#e8e8e8' }}>
            Activate Staff Account
          </h2>
          <p style={{ fontSize: 12, color: '#3a5a8a', marginTop: 4 }}>
            Enter the username your manager gave you, plus the phone number they have on file for you — then choose your PIN.
          </p>
        </div>
        <form onSubmit={handleActivate}>
          <div className="field">
            <label>Username</label>
            <input type="text" placeholder="Given to you by your manager"
              value={username} onChange={e => setUsername(e.target.value)} required />
          </div>
          <div className="field">
            <label>Your Phone Number</label>
            <input type="tel" placeholder="The number on file for you"
              value={phone} onChange={e => setPhone(e.target.value)} required />
          </div>
          <div className="field">
            <label>Choose a PIN</label>
            <input type="password" placeholder="••••" maxLength={6}
              value={pin} onChange={e => setPin(e.target.value)} required />
          </div>
          <div className="field">
            <label>Confirm PIN</label>
            <input type="password" placeholder="••••" maxLength={6}
              value={confirmPin} onChange={e => setConfirmPin(e.target.value)} required />
          </div>
          {error && <p style={{ color: '#c0101a', fontSize: 13, marginBottom: 12 }}>{error}</p>}
          <button className="btn-primary" type="submit" disabled={loading} style={{ marginTop: 8 }}>
            {loading ? 'Activating...' : 'Activate & Sign In'}
          </button>
        </form>
        <p style={{ textAlign: 'center', marginTop: 16, fontSize: 12 }}>
          <span style={{ color: '#1e6bff', cursor: 'pointer' }} onClick={() => navigate('/staff')}>
            Already activated? Sign in
          </span>
        </p>
      </div>
    </div>
  );
}
